import {
    APIType,
    ContouringCustomizationFile,
    UserCustomization,
} from '~/backend/types';
import { useAutoSegmentation } from '~/hooks/workflows/backend/tasks/useAutoSegmentation';
import {
    useBackendModels,
    useModelCustomizations,
} from '~/hooks/workflows/backend/useBackend';
import AutoSegmentation from './AutoSegmentation';

export default function ContourBackendWorkflow() {
    const { startProcessing, isSubmitting } = useAutoSegmentation();
    const { data: availableModels = [], isLoading: isLoadingModels } =
        useBackendModels(APIType.CONTOURING);
    const {
        data: modelCustomizations = [],
        isLoading: isLoadingCustomizations,
    } = useModelCustomizations(APIType.CONTOURING);

    return (
        <AutoSegmentation
            availableModels={availableModels}
            modelCustomizations={
                modelCustomizations as UserCustomization<ContouringCustomizationFile>[]
            }
            onSubmit={startProcessing}
            isLoadingModels={isLoadingModels || isLoadingCustomizations}
            isSubmitting={isSubmitting}
            showPseudonymization={true}
            error={null}
        />
    );
}
